// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrowseMediaSearchInput_wrapper__1215C","input":"BrowseMediaSearchInput_input__A-zEa"};